import { PasswordModal } from '@/scripts/optional/password-modal'
import { LandingPolicyController } from '@/scripts/optional/landing-policy-controller'
import { TsDOM as q} from '@/scripts/core/TsDOM'
import { ModalDialog } from '@/scripts/theme/modal-dialog';
import { ModalOpener } from '@/scripts/theme/modal-opener';

q.safeDefineElement(ModalDialog)
q.safeDefineElement(ModalOpener)
q.safeDefineElement(PasswordModal)
q.safeDefineElement(LandingPolicyController)
